import { useToast } from "contexts/ToastContext";
import { useState } from "react";
import { updateLegislativeDrafting } from "services/legislativeService";
import { CanShow } from "utils/authRules";
import { LoadingIcon } from "utils/constant";
import { LEGISLATIVE_DRAFTING_REQUEST_STATUS } from "utils/constantValues";
import UploadDraftLaw from "./uploadDraftLaw";
import RequestForAdditionalInfo from "./uploadRequestForAdditionalInfo";
import { useTranslation } from "react-i18next";

export default function ProsecutorRemark({ setFormState, formState, isInternal }: { setFormState: any, formState: any, isInternal?: boolean }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);

    const handleCloseModal = () => {
        setIsModalOpen(false);
    }
    const handleRequestCloseModal = () => {
        setIsRequestModalOpen(false);
    }

    const handleReject = () => {
    }

    const handleUploadProposalClick = () => {
    }

    return (
        <>
            <div className="mt-4 pb-8 border-b border-gray-200">
                <div className="mb-3">
                    <p className="text-sm font-semibold text-[#0A1D39]">{t("TranslationReviewActions") || "Translation Review Actions"}</p>
                    <p className="text-xs text-gray-500 mt-0.5">
                        {isInternal
                            ? (t("SummaryWrittenCommentsHint") || "Prepare and submit your written comments summary for this translation request.")
                            : (t("TranslationReviewActionsHint") || "Submit your written comments summary, or request additional information from the requester.")}
                    </p>
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                {!isInternal && (
                    <button
                        type="button"
                        className="inline-flex flex-1 items-center justify-center gap-2 px-5 py-2.5 rounded-lg border border-[#0A1D39] text-[#0A1D39] text-sm font-semibold hover:bg-[#0A1D39] hover:text-white focus:outline-none focus:ring-2 focus:ring-[#0A1D39]/30 transition-colors disabled:opacity-50"
                        onClick={() => setIsRequestModalOpen(true)}
                        disabled={loading}
                    >
                        {loading ? (
                            <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                        ) : (
                            <>
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                {t("RequestForAdditionalInfo") || "Request for Additional Info"}
                            </>
                        )}
                    </button>
                )}
                <button
                    type="button"
                    onClick={() => setIsModalOpen(true)}
                    disabled={loading}
                    className="inline-flex flex-1 items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-[#0A1D39] text-white text-sm font-semibold shadow-sm hover:bg-[#13294d] focus:outline-none focus:ring-2 focus:ring-[#0A1D39]/40 transition-colors disabled:opacity-50"
                >
                    {loading ? (
                        <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                    ) : (
                        <>
                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            {t("SummaryWrittenComments") || "Summary Written Comments"}
                        </>
                    )}
                </button>
                </div>
            </div>
            <UploadDraftLaw
                request={formState}
                setLegalResearch={setFormState}
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onUploadProposal={handleUploadProposalClick}
                type="legal_translation"
            />
            <RequestForAdditionalInfo
                request={formState}
                setLegalResearch={setFormState}
                isOpen={isRequestModalOpen}
                onClose={handleRequestCloseModal}
                onUploadProposal={handleUploadProposalClick}
            />
        </>
    );
}